module.exports = __webpack_public_path__ + "img/account_mb_02.4fe5390c.jpg";